import { render, staticRenderFns } from "./addxyk.vue?vue&type=template&id=03db21a9&scoped=true"
import script from "./addxyk.vue?vue&type=script&lang=js"
export * from "./addxyk.vue?vue&type=script&lang=js"
import style0 from "./addxyk.vue?vue&type=style&index=0&id=03db21a9&prod&lang=less&scoped=true"
import style1 from "./addxyk.vue?vue&type=style&index=1&id=03db21a9&prod&lang=css"
import style2 from "./addxyk.vue?vue&type=style&index=2&id=03db21a9&prod&lang=less&scoped=true"
import style3 from "./addxyk.vue?vue&type=style&index=3&id=03db21a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03db21a9",
  null
  
)

export default component.exports